import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ width = "40", height = "40", fill = "#858e95" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 104.526 80.128"
    >
      <g id="folder" transform="translate(0 -47.618)">
        <g
          id="Сгруппировать_3751"
          data-name="Сгруппировать 3751"
          transform="translate(0 47.619)"
        >
          <path
            id="Контур_720"
            data-name="Контур 720"
            d="M95.3,58.133H52.858L44.4,48.08a1.281,1.281,0,0,0-1.025-.461H9.223A9.315,9.315,0,0,0,0,56.945v61.486a9.315,9.315,0,0,0,9.223,9.315H95.3a9.315,9.315,0,0,0,9.223-9.315V67.449A9.315,9.315,0,0,0,95.3,58.133Z"
            transform="translate(0 -47.619)"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
};

export default memo(Icon);
